import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DebugBar from '@chama/ui-components/components/DebugBar';
import { enableDebugging, disableDebugging, setLocale } from '@app/actions/feature-toggles';

const mapStateToProps = state => ({
  debuggingEnabled: state.featureToggles.debuggingEnabled,
  locale: state.featureToggles.locale,
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      enableDebugging,
      disableDebugging,
      setLocale,
    },
  )(DebugBar),
);



// WEBPACK FOOTER //
// ./src/containers/DebugBar.jsx